export const validateAndTouchAllFields = async <TValues extends Record<string, any>>(
  validateForm: () => Promise<Partial<Record<keyof TValues, any>>>,
  setTouched: (touched: Partial<Record<keyof TValues, any>>, shouldValidate?: boolean) => void,
  values: TValues,
  generatePdf: (values: TValues) => void
) => {
  const errors = await validateForm();

  if (Object.keys(errors).length > 0) {
    const touchAllFields = (obj: Record<string, any>): Record<string, any> => {
      return Object.keys(obj).reduce((acc: Record<string, any>, key: string) => {
        const value = obj[key];

        if (value && typeof value === 'object' && !Array.isArray(value)) {
          acc[key] = touchAllFields(value);
        } else if (Array.isArray(value)) {
          acc[key] = value.map((item: any) => touchAllFields(item));
        } else {
          acc[key] = true;
        }

        return acc;
      }, {});
    };

    setTouched(touchAllFields(errors) as Partial<Record<keyof TValues, any>>, true);
  } else {
    generatePdf(values);
  }
};